import { NormalText } from '../../shared/styles'
import { WalletStyled } from './styles'
import { formatLargeText } from '../../shared/utils'
import { Box } from '@mui/material'

import { Announcement } from '../../shared/announcement/announcement'
import { CopyButton } from '../../shared/copy-button/copy-button'

export const Wallet = ({ polygonAddress, tronAddress }) => {
  return (
    <WalletStyled>
      <Announcement
        title="Deposit wallet"
        description={
          'This is your unique deposit address. Currently, only MATIC (Polygon) network is supported. More networks will be available soon.'
        }
        withInfoIcon
      />
      <Box display="flex" flexDirection="column" gap={'8px'} mt={'16px'}>
        {polygonAddress && (
          <>
            <NormalText>Polygon address</NormalText>
            <Box display="flex" alignItems="center" gap={'8px'}>
              <NormalText size={14} color="#0F110C" isBold>
                {formatLargeText(polygonAddress)}
              </NormalText>
              <CopyButton
                tooltipText="Copy"
                textToCopy={polygonAddress}
                iconColor="#0F110C"
                iconSize={14}
              />
            </Box>
          </>
        )}
        {tronAddress && (
          <>
            <NormalText>Tron address</NormalText>
            <Box display="flex" alignItems="center" gap={'8px'}>
              <NormalText size={14} color="#0F110C" isBold>
                {formatLargeText(tronAddress)}
              </NormalText>
              <CopyButton
                tooltipText="Copy"
                textToCopy={tronAddress}
                iconColor="#0F110C"
                iconSize={14}
              />
            </Box>
          </>
        )}
        {!polygonAddress && !tronAddress && (
          <NormalText>No wallets found, please contact support</NormalText>
        )}
      </Box>
    </WalletStyled>
  )
}
